import React from "react";
import { Redirect, Link } from "react-router-dom";
import Cookies from "universal-cookie";
import { connect } from "react-redux";
import {
  getRecibos,
  publicarLote,
  aceptarRRHHLote,
  aceptarRLLote,
  enviarLoteMtess,
  getEnviarNotificacion,
} from "./RecibosService";
import "../../styles/Empresa.css";
import Pin from "../recibos/Pin";
import {
  verificarRol,
  firmaRRHH,
  firmaRL,
  URL,
  gestorEmpresa,
} from "../../constans/constants";
import {
  Modal,
  ModalBody,
  Container,
  Row,
  Col,
  Button,
  Spinner,
} from "react-bootstrap";
import SeleccionPca from "../pca/SeleccionPca";
import LoginPsa from "../pca/LoginPsa";
import PantallaCarga from "../mensajeFlash/PantallaCarga";
import { obtenerLote } from "../lotes/LoteService";
import arrowBack from "../../styles/icons/arrow_back.svg";
import pdfIcon from "../../styles/icons/pdf.svg";
import ExclamacionIcon from "../../styles/icons/exclamation-circle.svg";
import xCircle from "../../styles/icons/x-circle.svg";
import checkCircle from "../../styles/icons/check-circle.svg";
import search from "../../styles/icons/search.svg";
import MensajeFlash from '../mensajeFlash/MensajeFlash';
import BreadCrumComponent from '../componentes/BreadCrumComponent';
import TablaLoteDetalle from "../componentes/tablas/TablaLoteDetalle";
import ModalMensajePersonalizado from "../componentes/modales/ModalMensajesPersonalizado";
import ModalRecordatorioFirma from "../componentes/modales/ModalRecordatorioFirma";
import ModalPublicarLote from "../componentes/modales/ModalPublicarLote";
import ModalAceptarLote from "../lotes/ModalAceptarLote";


class Recibos extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogTitle: "Ingrese Pin de Firma",
      dialogType: "add",
      submitText: "Guardar",
      disabledInput: false,
      selectedRecibo: {
        recibo: "",
        fechaCarga: "",
        empleado: "",
        estado: "",
        estadoMTESS: false,
      },
      idLote: "",
      fechaImportacionLote: "",
      descripcionLote: "",
      formatoDocumentoLote: "",
      cantidadDocumentoLote: "",
      firmaLote: null,
      numeroLote: "",
      tipoFirma: "",
      redirect: false,

      openMsgVentana: false,
      openSpinner: false,
      msgVentana: "",
      error: false,

      dialogIsOpen: false,
      dialogIsOpenVerDatos: false,
      dialogPinOpen: localStorage.getItem("tokenIscert") != null ? true : false,
      dialogAceptLote: false,
      open: false,

      openPantallaCarga: false,
      msjPantallaCarga: null,

      dialogEnvioNotificacion: false,

      dialogEnvioMtess: false,
      mostrarMensajeFlash: false,
      mensajeFlash: null,
      mensajeFlashSeverity: "neutral",
      openSeleccionPca: false,
      openLoginPSA: false,
      recibos: [],
      page: 0,
      pageSize: 10,
      totalCount: 0,
      totalPages: 0,
      search: "",
      loading: true,
    };
    localStorage.removeItem("redirectURLFirma");
    let pantallaAnterior = null;
    const datosPsa = null;
    const psaActivos = null;
    this.tableRef = React.createRef();
    this.modalRecordatorioRef = React.createRef();
    this.modalPublicarLote = React.createRef();
    this.modalSeleccionPsa = React.createRef();
    this.modalAceptarLote = React.createRef();
    this.modalMensaje = React.createRef();
    this.setPantallaAnterior();
  }

  componentDidMount() {
    obtenerLote(this.props.match.params.idLote).then((res) => {
      this.setState({
        idLote: res.datos.loteRecibos.id,
        fechaImportacionLote: res.datos.loteRecibos.fechaCarga,
        descripcionLote: res.datos.loteRecibos.descripcion,
        formatoDocumentoLote:
          res.datos.loteRecibos.tipoDocumento.formato.extension,
        cantidadDocumentoLote: res.datos.loteRecibos.recibidos,
        numeroLote: res.datos.loteRecibos.numero,
        firmaLote: res.datos.loteRecibos.tipoDocumento.firmaEmpresa,
      });

      this.psaActivos = res.datos.psaActivos;

    });

  }
  handleDialog = (value) => {
    this.setState({
      dialogIsOpen: value,
    });
  };

  setPantallaAnterior = () => {
    localStorage.setItem("urlAnterior", window.location.href);
    this.pantallaAnterior = localStorage
      .getItem("urlRaiz")
      .substring(localStorage.getItem("urlRaiz").indexOf("#"));
  };

  handleClosePsa = () => {
    this.setState({ openSeleccionPca: false });
  };

  handleDialogEnvioMtess = (value) => {
    this.setState({
      dialogEnvioMtess: value,
    });
  };

  handleDialogAceptLote = (value) => {
    this.setState({
      dialogAceptLote: value,
    });
  };

  handleMsgVentana = (value) => {
    !value
      ? this.modalMensaje.current.cerrarModalConAnimacion()
      : this.setState({ openMsgVentana: value, redirect: true });

  };

  handleLoginPSA = (value, data) => {
    if (data != null) {
      if (data.error) {
        this.setState({
          openLoginPSA: false,
          openMsgVentana: true,
          error: true,
          msgVentana: data.mensaje,
        });
      } else {
        localStorage.setItem("tokenIscert", data.datos.access_token);
        localStorage.setItem("codigoClienteFirma", this.datosPsa.id);
        localStorage.setItem("proveedorFirma", this.datosPsa.codigoCliente);
        this.setState({
          openLoginPSA: false,
          openMsgVentana: true,
          error: false,
          msgVentana: "Autenticado con exito",
        });
      }
    } else {
      this.setState({
        openLoginPSA: value,
      });
    }
  };

  

  handleDialogPin = (open, data, firma) => {

    if (localStorage.getItem("tokenIscert") == null) {
      this.setState({ openSeleccionPca: open });
      return;
    }

    localStorage.removeItem("tokenIscert");
    localStorage.removeItem("codigoClienteFirma");
    localStorage.removeItem("proveedorFirma");

    if (data.error) {
      this.setState({
        msgVentana: data.mensaje,
        openMsgVentana: true,
        error: data.error
      });
    } else {
      this.setState({ dialogPinOpen: open, tipoFirma: firma, redirect: false });
      this.props.history.push({
        pathname: '/lote/firmar/' + (data.error ? 'error' : 'exito'),
        state: {
          cantidadRecibos: this.state.cantidadDocumentoLote,
          descripcionLote: this.state.descripcionLote,
          fechaImportacionLote: this.state.fechaImportacionLote,
          errorDetalle: data.error ? data.mensaje : null,
          backUrl: this.props.location.pathname
        }
      });
    }
  };

  handleClose = (value) => {
    this.setState({
      open: value,
    });
  };

  formatearFecha = (fechaString) => {
    // Verificar que la fecha tenga el formato correcto
    if (!/^\d{4}-\d{2}-\d{2}$/.test(fechaString)) {
      return "Formato de fecha inválido. Use AAAA-MM-DD";
    }

    // Crear un objeto Date a partir del string
    const fecha = new Date(fechaString);

    // Verificar que la fecha sea válida
    if (isNaN(fecha)) {
      return "Fecha inválida";
    }

    const meses = [
      "enero", "febrero", "marzo", "abril", "mayo", "junio",
      "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"
    ];

    const mes = meses[fecha.getMonth()];
    const dia = fecha.getDate();
    const anio = fecha.getFullYear();

    return `${dia} de ${mes} ${anio}`;
  }


  enviarNotificacion = () => {
    this.modalRecordatorioRef.current.cerrarModalConAnimacion()
    this.setState({ openPantallaCarga: true })
    let idLote = this.state.idLote;
    getEnviarNotificacion(idLote).then((res) => {
      this.setState({ openPantallaCarga: false });
      this.setState({
        mostrarMensajeFlash: true,
        mensajeFlash: res.mensaje,
        mensajeFlashSeverity: res.error ? 'error' : 'exito',
      });
    });
  };

  descargarLote = () => {
    window.location.href = URL + "lote/descargar/" + this.state.idLote;
  };

  enviarLoteMtess = () => {
    const cookies = new Cookies();
    let idLote = this.state.idLote;
    let username = cookies.get("username");
    enviarLoteMtess(idLote, username).then((res) => {
      this.setState({ msgVentana: res.mensaje, openMsgVentana: true });
      this.handleDialogEnvioMtess(false);
    });
  };

  visualizarBotones = () => {
    if ((this.props.match.params.estado == "nuevo" && verificarRol(this.props.roles, firmaRRHH)) ||
      (this.props.match.params.estado == "firmado" && verificarRol(this.props.roles, firmaRL))
    ) {
      return this.state.firmaLote ? (
        <button onClick={() => this.handleDialogPin(true)} className="btn-medium btn-primary">
          <span className="material-symbols-outlined"> history_edu </span> Firmar Lote
        </button>
      ) : (
        <button onClick={this.handleDialogAceptLote} className="btn-medium btn-primary">
          <span className="material-symbols-outlined">thumb_up</span> Aceptar Lote
        </button>
      );
    }

    if (this.props.match.params.estado == "publicar") {
      return (
        <button onClick={this.handleClose} className="btn-medium btn-primary">
          <span className="material-symbols-outlined">publish</span> Publicar lote
        </button>
      );
    }
    if (
      this.props.match.params.estado == "publicados" &&
      verificarRol(this.props.roles, gestorEmpresa)
    ) {
      return (
        <button onClick={() => this.setState({ dialogEnvioNotificacion: true })} className="btn-medium btn-primary">
          <span className="material-symbols-outlined">forward_to_inbox</span> Enviar recordatorio
        </button>
      );
    }
    if (this.props.match.params.estado == "cerrado") {
      return (
        <button onClick={this.handleDialogEnvioMtess} className="btn-medium btn-primary">
          <span className="material-symbols-outlined">publish</span> Enviar al MTESS
        </button>
      );
    }
  };

  publicarLote = () => {
    this.setState({ openPantallaCarga: true, open: false });
    publicarLote(this.state.idLote).then((response) => {
      this.props.history.push({
        pathname: '/lote/publicar/' + (response.error ? 'error' : 'exito'),
        state: {
          cantidadRecibos: this.state.cantidadDocumentoLote,
          descripcionLote: this.state.descripcionLote,
          fechaImportacionLote: this.state.fechaImportacionLote,
          errorDetalle: response.error ? response.mensaje : null,
          backUrl: this.props.location.pathname
        }
      })
    });
  };

  aceptarRRHH = () => {
    this.setState({ openPantallaCarga: true });
    aceptarRRHHLote(this.state.idLote).then((response) => {
      this.handleRedirect(response)
    });
  };

  aceptarRL = () => {
    this.setState({ openPantallaCarga: true });
    aceptarRLLote(this.state.idLote).then((response) => {
      this.handleRedirect(response)
    });
  };

  handleRedirect = (response) => {
    this.props.history.push({
      pathname: '/lote/aceptar/' + (response.error ? 'error' : 'exito'),
      state: {
        cantidadRecibos: this.state.cantidadDocumentoLote,
        descripcionLote: this.state.descripcionLote,
        fechaImportacionLote: this.state.fechaImportacionLote,
        errorDetalle: response.error ? response.mensaje : null,
        backUrl: this.props.location.pathname
      }
    })
  }

  validarMtess = () => {
    return this.props.match.params.estado == "cerrado";
  };


  render() {
    return (
      <div>
        <PantallaCarga
          open={this.state.openPantallaCarga}
          mensaje={this.state.msjPantallaCarga}
        />

        <Modal
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={this.state.dialogEnvioMtess}
          backdrop="static"
          keyboard="false"
        >
          <Container>
            <Modal.Body>
              <Row className="justify-content-center">
                <Col className="text-center text-md-right">
                  <img
                    src={ExclamacionIcon}
                    style={{ margin: "40px" }}
                  ></img>
                </Col>
              </Row>
              <Row className="justify-content-center">
                <Col className="text-center text-md-right">
                  <p>
                    <strong>
                      ¿Está seguro que desea enviar este lote a MTESS?
                    </strong>
                  </p>
                </Col>
              </Row>
              <Row style={{ background: "#EDF2F9", padding: "5px" }}>
                <Col>
                  <p>
                    <strong>Lote: </strong>
                    {this.state.idLote} |{" "}
                    {this.state.fechaImportacionLote}
                  </p>
                  <p>
                    <strong>Descripcion:</strong>{" "}
                    {this.state.descripcionLote}
                  </p>
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer>
              <Button
                onClick={() => this.handleDialogEnvioMtess(false)}
                variant="ligth"
              >
                Cancelar
              </Button>
              <Button
                onClick={this.enviarLoteMtess}
                variant="primary"
                autoFocus
              >
                Enviar
              </Button>
            </Modal.Footer>
          </Container>
        </Modal>

        <ModalAceptarLote
          ref={this.modalAceptarLote}
          isOpen={this.state.dialogAceptLote}
          onConfirmar={
            this.props.match.params.estado == "firmado"
              ? this.aceptarRL
              : this.aceptarRRHH
          }
          tipoDocumento="lote"
          cerrarModal={() => this.setState({ dialogAceptLote: false })}
        />

        <ModalMensajePersonalizado
          ref={this.modalMensaje}
          isOpen={this.state.openMsgVentana}
          error={this.state.error}
          msg={this.state.msgVentana}
          accion={() => this.handleMsgVentana(false)}
          onClose={() => this.setState({ openMsgVentana: false })}
        />

        <SeleccionPca
          ref={this.modalSeleccionPsa}
          isOpen={this.state.openSeleccionPca}
          cerrarModal={this.handleClosePsa}
          url={window.location.href}
          listaPsa={this.psaActivos}
        />

        {/*
        <Modal
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={this.state.openSeleccionPca}
          onHide={this.handleClosePsa}
          backdrop="static"
          keyboard="false"
        >
          <SeleccionPca
            handleClose={this.handleClosePsa}
            url={window.location.href}
            listaPsa={this.psaActivos}
          />
        </Modal>
*/}
        <ModalPublicarLote
          ref={this.modalPublicarLote}
          isOpen={this.state.open}
          onConfirmar={this.publicarLote}
          cerrarModal={() => this.setState({ dialogEnvioNotificacion: false })}
          elemento={{ 'descripcionLote': this.state.descripcionLote, 'numeroLote': this.state.numeroLote, 'fechaImportacion': this.state.fechaImportacionLote }}
          detallesAMostrar={[
            { clave: 'numeroLote', etiqueta: 'Lote Nro.' },
            { clave: 'descripcionLote', etiqueta: 'Descripcion' },
            { clave: 'fechaImportacion', etiqueta: 'Fecha de importacion' },
          ]}
        />

        <ModalRecordatorioFirma
          ref={this.modalRecordatorioRef}
          isOpen={this.state.dialogEnvioNotificacion}
          onConfirmar={this.enviarNotificacion}
          cerrarModal={() => this.setState({ dialogEnvioNotificacion: false })}
        />

        <div className="template-base">
          <header className="component-header">
            <div className="page-container">

              <BreadCrumComponent
                backUrl='/lote/nuevos'
                breadcrumbs={
                  [
                    { label: 'Lotes', path: '/lote/nuevos' },
                    { label: 'Detalles del lote', path: '' }
                  ]
                }
              />
              <div className="head-area">
                <div className="caption-area">
                  <h1 className="page-title"> {this.state.descripcionLote} </h1>
                  <p className="page-description"> Lote de documentos nro. {this.state.numeroLote}, importado en fecha {this.formatearFecha(this.state.fechaImportacionLote)} </p>
                </div>
                <div className="head-actions">
                  <button onClick={this.descargarLote} className="btn-medium btn-base-outline">
                    <span className="material-symbols-outlined">download</span> Descargar
                  </button>
                  {this.visualizarBotones()}
                </div>
              </div>
            </div>
          </header>
          <div className="wrapperContainer">
            <div className="page-container">
              <TablaLoteDetalle idLote={this.props.match.params.idLote} />
            </div>
            <MensajeFlash
              visible={this.state.mostrarMensajeFlash}
              mensaje={this.state.mensajeFlash}
              severity={this.state.mensajeFlashSeverity} />
          </div>
        </div>
        <Pin
          isOpen={this.state.dialogPinOpen}
          estado={this.props.match.params.estado}
          //idLote={this.state.idLote}
          numeroLote={this.state.numeroLote}
          idLote={this.props.match.params.idLote}
          formatoDocumento={this.state.formatoDocumentoLote}
          fechaImportacionLote={this.state.fechaImportacionLote}
          descripcionLote={this.state.descripcionLote}
          cantidadDocumentoLote={this.state.cantidadDocumentoLote}
          type={this.state.dialogType}
          submitText={this.state.submitText}
          disabledInput={this.state.disabledInput}
          dialogTitle={
            this.state.tipoFirma == "RRHH"
              ? "Firma RRHH"
              : "Firma representante legal"
          }
          handleClose={(open, data, tipoFirma) => {
            if (data && data.error) {
              this.setState({
                msgVentana: data.mensaje || "Error al cargar datos de firma.",
                openMsgVentana: true,
                error: true,
                dialogPinOpen: false,
                tipoFirma: tipoFirma
              });
            } else if (typeof open === "boolean") {
              this.handleDialogPin(open, data, tipoFirma);
            }
          }}
        />
      </div>
    );
  }
  //}
}
const mapDispatchToProps = (dispatch) => ({
  getRecibos: (page, size, search, idLote) =>
    dispatch(getRecibos(page, size, search, idLote)),
});

const mapStateToProps = (state) => ({
  recibosData: state.recibosData,
  roles: state.rolesData,
  firmaRRHH: state.firmaRRHH,
  firmaRL: state.firmaRL,
});

export default connect(mapStateToProps, mapDispatchToProps)(Recibos);
